module.exports = __webpack_public_path__ + "static/media/Contact5050.e896719b.png";